"use client";
import {
  useTabStore
} from "../__chunks/RZ4N7DMG.js";
import "../__chunks/J4NXMVZC.js";
import "../__chunks/2YDG6Q4P.js";
import {
  TabContextProvider
} from "../__chunks/RVGP4EDO.js";
import "../__chunks/O6W3KMIU.js";
import "../__chunks/TCS6QBGM.js";
import "../__chunks/TN5Y26CD.js";
import "../__chunks/MTODTZOP.js";
import "../__chunks/M6ZUVZPG.js";
import "../__chunks/32IPIQBR.js";
import "../__chunks/EQMNTDLB.js";
import "../__chunks/PTCNA5XT.js";
import "../__chunks/FQ77EHUR.js";
import "../__chunks/WX6L4ACS.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/tab/tab-provider.tsx
import { jsx } from "react/jsx-runtime";
function TabProvider(props = {}) {
  const store = useTabStore(props);
  return /* @__PURE__ */ jsx(TabContextProvider, { value: store, children: props.children });
}
export {
  TabProvider
};
